import { defineStore } from "pinia";
import { nasna } from "../http-common.js"
import { acceptTVCode } from "@/Gql/auth.js";
import apolloClient from "../plugins/apollo";


export const useAuthStore = defineStore("auth", {
    state: () => {
        return {
            isLoggedin: Boolean, // check user status 
            user: JSON.parse(localStorage.getItem("user")), // user data to be stored 
            token: "",
            isAuthenticatedUser: false,
            status: window.localStorage.getItem("status"),
            isActive: window.localStorage.getItem("isActive") === "true"

        }
    },// end of state
    getters: {
        getUser: (state) => state.user,
        isAuthenticated: (state) => state.isAuthenticatedUser,
        getPhone: (state) => state.user.phone,
        getISActive: (state) => state.isActive,

    }, //end of getters 
    actions: {
        /**
    * 
    * subscribe  
    */
        async subscribeAction() {
            window.location.href = "https://cgmtnsd.digitalsp.net/632/OrMW"

        },
        /**
         * login user for authentication purpose 
         */
        async verifyTvPinCode(userID, code) {
            console.log("FROM AUTH STORE");
            console.log(userID, code);
            return new Promise((resolve, reject) => {
              apolloClient
                .mutate({
                  mutation: acceptTVCode,
                  variables: {
                    userId: userID, // Corrected variable name
                    code
                  },
                })
                .then((response) => {
                  console.log(response.data.acceptTVCode);
                  resolve(response);
                })
                .catch((error) => {
                  this.error = error;
                  reject(error);
                });
            });
          },
        /**
         * checking user subscribtion status
         */
        async checkSubescriptionStatus(data) {
                
            const payloadCheck = {
                "CGMSISDN": data.phone,
                "CGSTATUS": "0"
            };
            if(data.user_id) {
                payloadCheck.user_id = data.user_id;
            }
                const response = await nasna.post(`/auth/mtn/subscriptions/check/`, payloadCheck);
                await this.setData(response);
                //console.log(response);
                // If condition is met, also call the campaign endpoint
                if (data.cgstatus == 0 || data.cgstatus == 5) {
                    //console.log("Data: ", data);
                    if(!data.clickId) {
                        console.error("pubId or clickId is missing");
                        return;
                    }
                    const payloadCampaign = {
                        pubID: data.pubId,
                        clickID: data.clickId,
                          operator: "MTN",
                    };
                    nasna.post(`/auth/mtn/subscriptions/campaign`, payloadCampaign)
                        .then(res => {
                            console.log(res.data);
                        })
                        .catch(err => {
                            console.error(err);
                        });
                }
                return response;
            
        },
        async redirectMtnLandgPage(data) {

            if (data.responseCode == 0) {
                window.location.href = `${data.transactionDetails.url}?id=${data.transactionDetails.id}`;
            }
        },
        async setData(response) {
            if (response.data.success) {
                window.localStorage.removeItem("logout")
                window.localStorage.setItem('user', JSON.stringify(response.data.user));
                window.localStorage.setItem('token', response.data.token);
                window.localStorage.setItem('key', response.data.key);
                window.localStorage.setItem('isActive', response.data.token ? true : false);

                this.user = response.data.user;
                this.isActive = !!response.data.token;

            } else {
                this.wipeUserData(response)
            }

        },

        async unsubscribe() {
            let msisdns = localStorage.getItem("msisdn");
            var dataa = JSON.parse(msisdns)


            if (dataa != null) {


                return new Promise((resolve) => {
                    nasna.get(`auth/mtn/subscriptions/cancel/${dataa.msisdn}`).then((response) => (
                        this.wipeUserData(response),
                        resolve(response)));

                })

            }
        },

        wipeUserData(response) {
            if (response.data.status == false && response.data.isActive == false) {
                window.localStorage.removeItem("user"),
                    window.localStorage.removeItem("token"),
                    window.localStorage.removeItem("isActive")

                this.user = null
                this.isActive = false
            }
        },




        /**
         * logout the current authenticated user
         */
        logOut() {
            window.localStorage.removeItem("user")
            window.localStorage.removeItem("token")
            window.localStorage.removeItem("key")
            window.localStorage.removeItem("isActive")
            window.localStorage.setItem("logout", true)

            this.user = null
            this.token = ""
            this.isActive = false
            this.isAuthenticatedUser = false
        }
    }
})